module.exports = __webpack_public_path__ + "static/media/skill-git.99acf082.png";